import InputNew from './InputNew';

export default InputNew;
